'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CartDrawer = exports.CLASS_CART_DRAWER_OPEN = exports.CART_UPSELL_PRICE = exports.CART_UPSELL_BUTTON = exports.CART_DRAWER_INFO = exports.CART_DRAWER_SELECTOR = exports.CART_DRAWER_VARIANT_BUTTON = exports.CART_DRAWER_TOGGLE = exports.CONTAINER_SELECTOR = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

var _pcSlateTools = require('@process-creative/pc-slate-tools');

var _Cart2 = require('./../../components/cart/Cart');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Selectors
/*
 *  Cart Drawer
 *    Provides scripts for the cart drawer.
 *
 *  Version:
 *    1.0.0 - 2020/04/28
 */

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-cart-drawer]';
var CART_DRAWER_TOGGLE = exports.CART_DRAWER_TOGGLE = '[data-cart-drawer-toggle]';
var CART_DRAWER_VARIANT_BUTTON = exports.CART_DRAWER_VARIANT_BUTTON = '[data-variant-button]';
var CART_DRAWER_SELECTOR = exports.CART_DRAWER_SELECTOR = '[data-variant-mobile]';
var CART_DRAWER_INFO = exports.CART_DRAWER_INFO = '[data-info-block]';
var CART_UPSELL_BUTTON = exports.CART_UPSELL_BUTTON = '[data-cart-upsell-add-btn]';
var CART_UPSELL_PRICE = exports.CART_UPSELL_PRICE = '[data-product-money]';

var SELECTOR_UPSELL_CONTAINER = '[data-upsell-container]';
var SELECTOR_UPSELL_TEMPLATE = '[data-upsell-template]';

//Classes
var CLASS_CART_DRAWER_OPEN = exports.CLASS_CART_DRAWER_OPEN = 'is-cart-open';

var CartDrawer = exports.CartDrawer = function (_Cart) {
  (0, _inherits3.default)(CartDrawer, _Cart);

  function CartDrawer(container) {
    (0, _classCallCheck3.default)(this, CartDrawer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CartDrawer.__proto__ || Object.getPrototypeOf(CartDrawer)).call(this, container));

    _this.body = (0, _jquery2.default)('body');
    _this.drawerTargets = [_this.body, _this.container];

    //Events
    (0, _jquery2.default)(document).on('click touchend', CART_DRAWER_TOGGLE, function (e) {
      return _this.onCartToggle(e);
    });
    // $(document).on(ON_CART_FINISHED, () => this.onCartFinished());

    if ((0, _jquery2.default)(window).width() < ResponsiveSizes.medium) {
      (0, _jquery2.default)(document).on('click touchend', CART_DRAWER_VARIANT_BUTTON, function (e) {
        return _this.openVariantSelector(e);
      });
    }
    (0, _jquery2.default)(window).on('resize orientationchange', function (e) {
      return _this.onResize(e);
    });
    _this.moveUpsellCarousel();
    return _this;
  }

  (0, _createClass3.default)(CartDrawer, [{
    key: 'open',
    value: function open() {
      this.drawerTargets.forEach(function (e) {
        return (0, _jquery2.default)(e).addClass(CLASS_CART_DRAWER_OPEN);
      });
    }
  }, {
    key: 'close',
    value: function close() {
      this.drawerTargets.forEach(function (e) {
        return (0, _jquery2.default)(e).removeClass(CLASS_CART_DRAWER_OPEN);
      });
      this.closeVariantSelector();
    }
  }, {
    key: 'onCartFinished',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var cart, count;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, _get3.default)(CartDrawer.prototype.__proto__ || Object.getPrototypeOf(CartDrawer.prototype), 'onCartFinished', this).call(this);
                cart = (0, _pcSlateTools.getCurrentCart)();
                count = cart.item_count;

                //Finally, show the cart if it wasn't already visible.

                if (!this.container.hasClass(CLASS_CART_DRAWER_OPEN)) this.open();

                // Close cart if it has no items
                if (count < 1) this.close();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onCartFinished() {
        return _ref.apply(this, arguments);
      }

      return onCartFinished;
    }()
  }, {
    key: 'moveUpsellCarousel',
    value: function moveUpsellCarousel() {
      //Move upsell elements into the correct location for the cart drawer
      var upsellTemplate = this.productsContainer.find(SELECTOR_UPSELL_TEMPLATE);
      var upsellContainer = this.container.find(SELECTOR_UPSELL_CONTAINER);

      if (upsellTemplate.length && upsellContainer.length) {
        upsellTemplate.detach();
        upsellContainer.html(upsellTemplate);
        if ((0, _jquery2.default)(window).width() < ResponsiveSizes.medium) this.openVariantSelector();
      }
    }
  }, {
    key: 'onCartToggle',
    value: function onCartToggle(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.container.hasClass(CLASS_CART_DRAWER_OPEN)) return this.close();
      this.open();
      this.updatePromoMessages();

      if ((0, _jquery2.default)(window).width() < ResponsiveSizes.medium) this.openVariantSelector(e);
    }
  }, {
    key: 'openVariantSelector',
    value: function openVariantSelector(e) {
      if (e) e.preventDefault();
      if (this.container.length === 0) return;
      var variantButton = (0, _jquery2.default)(this.container).find(CART_DRAWER_VARIANT_BUTTON);
      var variantSelector = (0, _jquery2.default)(this.container).find(CART_DRAWER_SELECTOR);
      var info = (0, _jquery2.default)(this.container).find(CART_DRAWER_INFO);
      var upsellButton = (0, _jquery2.default)(this.container).find(CART_UPSELL_BUTTON);
      var upsellPrice = (0, _jquery2.default)(this.container).find(CART_UPSELL_PRICE);

      upsellPrice.addClass('is-variant-selector');
      info.addClass('is-hidden');
      variantButton.addClass('is-hidden');
      variantSelector.removeClass('is-hidden');
      upsellButton.removeClass('is-hidden');
    }
  }, {
    key: 'closeVariantSelector',
    value: function closeVariantSelector() {
      if (this.container.length === 0) return;
      var variantButton = (0, _jquery2.default)(this.container).find(CART_DRAWER_VARIANT_BUTTON);
      var variantSelector = (0, _jquery2.default)(this.container).find(CART_DRAWER_SELECTOR);
      var info = (0, _jquery2.default)(this.container).find(CART_DRAWER_INFO);
      var upsellButton = (0, _jquery2.default)(this.container).find(CART_UPSELL_BUTTON);
      var upsellPrice = (0, _jquery2.default)(this.container).find(CART_UPSELL_PRICE);

      upsellButton.addClass('is-hidden');
      variantSelector.addClass('is-hidden');
      info.removeClass('is-hidden');
      upsellPrice.removeClass('is-variant-selector');
      variantButton.removeClass('is-hidden');
    }
  }, {
    key: 'onResize',
    value: function onResize(e) {
      if ((0, _jquery2.default)(window).width() > ResponsiveSizes.medium) {
        this.closeVariantSelector();
      } else {
        this.openVariantSelector(e);
      }
    }
  }]);
  return CartDrawer;
}(_Cart2.Cart);

(0, _jquery2.default)(document).ready((0, _jquery2.default)(CONTAINER_SELECTOR).each(function (i, e) {
  return new CartDrawer((0, _jquery2.default)(e));
}));